import { APIService } from "services";

export const getSmsProviders = async (pageNo, pageSize, search) => {
  let res;
  if (search.length === 0) {
    res = await getAllSmsProviders(pageNo, pageSize);
  } else {
    try {
      res = await searchSmsProviders(search, pageNo, pageSize);
    } catch (err) {
      return { records: [], totalCount: 0 };
    }
  }
  if (res && res.data) {
    return res.data;
  } else {
    return { records: [], totalCount: 0 };
  }
};

export const addSmsProvider = (data) => {
  return APIService.api().post(`/sms_providers`, data);
};
export const updateSmsProvider = (id, data) => {
  return APIService.api().patch(`/sms_providers/${id}`, data);
};
export const getAllSmsProviders = (pageNo, pageSize) => {
  return APIService.api().get(
    `/sms_providers/?pageNo=${pageNo}&pageSize=${pageSize}`
  );
};
export const getOneSmsProvider = (id) => {
  return APIService.api().get(`/sms_providers/${id}`);
};
export const searchSmsProviders = (searchKey, pageNo, pageSize) => {
  return APIService.api().get(
    `/sms_providers/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`
  );
};
export const deleteSmsProvider = (id) => {
  return APIService.api().delete(`/sms_providers/${id}`);
};
